import {
  ALL_SIGNAL_STATUS_FILTER_VALUES,
  type SignalStatusFilterValue,
} from '@terra/shared-contracts-signals';
import type { SignalExecutionFilter } from '../../../store/tab/signalsTabScopedFilterStore';

export const SIGNAL_PRESENCE_FILTER_VALUES = ['WITH', 'WITHOUT'] as const;

export const isSignalStatusFilterValue = (
  value: string,
): value is SignalStatusFilterValue =>
  ALL_SIGNAL_STATUS_FILTER_VALUES.has(value);

export const toSignalPresenceFilter = (
  value: string | undefined,
): SignalExecutionFilter =>
  SIGNAL_PRESENCE_FILTER_VALUES.find((option) => option === value) ?? 'ALL';

export const toSignalPresenceFilterValue = (
  filter: SignalExecutionFilter,
): string[] => (filter === 'ALL' ? [] : [filter]);
